/*
 --------------------------------------------------
 --------------------------------------------------
     Table Name : LU_UserGroupTypes
 --------------------------------------------------
 --------------------------------------------------
 DO NOT MODIFY MANUALLY
 --------------------------------------------------
 -------------------------------------------------- */

// Types
export type Administrator = 'Administrator';
export type Course_Contributor = 'Course_Contributor';
export type Course_Monitor = 'Course_Monitor';
export type Course_Participant = 'Course_Participant';
export type Course_Patient = 'Course_Patient';
export type Course_Viewer = 'Course_Viewer';
export type Participant = 'Participant';
export type Scenario_Contributor = 'Scenario_Contributor';
export type Scenario_Patient = 'Scenario_Patient';
export type Scenario_Viewer = 'Scenario_Viewer';
export type Session_Contributor = 'Session_Contributor';
export type Session_Participant = 'Session_Participant';
export type Session_Patient = 'Session_Patient';
export type Session_Viewer = 'Session_Viewer';
export type SystemAdmin = 'SystemAdmin';

export type UserGroupType =
    | Administrator
    | Course_Contributor
    | Course_Monitor
    | Course_Participant
    | Course_Patient
    | Course_Viewer
    | Participant
    | Scenario_Contributor
    | Scenario_Patient
    | Scenario_Viewer
    | Session_Contributor
    | Session_Participant
    | Session_Patient
    | Session_Viewer
    | SystemAdmin;

// Constants
export const ADMINISTRATOR: UserGroupType = 'Administrator' as const;
export const COURSE_CONTRIBUTOR: UserGroupType = 'Course_Contributor' as const;
export const COURSE_MONITOR: UserGroupType = 'Course_Monitor' as const;
export const COURSE_PARTICIPANT: UserGroupType = 'Course_Participant' as const;
export const COURSE_PATIENT: UserGroupType = 'Course_Patient' as const;
export const COURSE_VIEWER: UserGroupType = 'Course_Viewer' as const;
export const PARTICIPANT: UserGroupType = 'Participant' as const;
export const SCENARIO_CONTRIBUTOR: UserGroupType = 'Scenario_Contributor' as const;
export const SCENARIO_PATIENT: UserGroupType = 'Scenario_Patient' as const;
export const SCENARIO_VIEWER: UserGroupType = 'Scenario_Viewer' as const;
export const SESSION_CONTRIBUTOR: UserGroupType = 'Session_Contributor' as const;
export const SESSION_PARTICIPANT: UserGroupType = 'Session_Participant' as const;
export const SESSION_PATIENT: UserGroupType = 'Session_Patient' as const;
export const SESSION_VIEWER: UserGroupType = 'Session_Viewer' as const;
export const SYSTEM_ADMIN: UserGroupType = 'SystemAdmin' as const;

const LU_UserGroupTypes = {
    ADMINISTRATOR,
    COURSE_CONTRIBUTOR,
    COURSE_MONITOR,
    COURSE_PARTICIPANT,
    COURSE_PATIENT,
    COURSE_VIEWER,
    PARTICIPANT,
    SCENARIO_CONTRIBUTOR,
    SCENARIO_PATIENT,
    SCENARIO_VIEWER,
    SESSION_CONTRIBUTOR,
    SESSION_PARTICIPANT,
    SESSION_PATIENT,
    SESSION_VIEWER,
    SYSTEM_ADMIN,
} as const;

export default LU_UserGroupTypes;
